import styled from '@emotion/styled';
import { spacing, breakpoints } from 'theme';

export const TextWrapper = styled.div({
  marginTop: spacing[28],
  '& > * + *': {
    marginTop: spacing[12],
  },
});

export const IconsWrapper = styled.div({
  display: 'flex',
  gap: spacing[8],
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: spacing[8],

  [`${breakpoints.mobile}`]: {
    justifyContent: 'flex-start',
  },
});
